import Icon from '../../components/Icon'

Icon.register({
  'brands/watchman-monitoring': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 16c132.5 0 240 107.5 240 240s-107.5 240-240 240-240-107.5-240-240 107.5-240 240-240zM121.7 429.1l27.7-204.9-9.5-7.4c-3-2.3-4.9-6-4.9-10 0-0.1 0-0.2 0-0.3 0-7 0.1-19.5 0.1-19.5l13.9-2 0.1-11-102.9 17.9c-6.2 20.3-9.6 41.7-9.6 64v0.1c0 70.3 33.3 133 84.9 173.1zM227.4 145.9l0 3.6 193.5-37.7c-40.1-46-99.1-75-164.9-75-74.5 0-140.4 37.4-180 94.3l73.5 19.2 0-4.4-8.5-7.6s-6.9-5.4 0.1-9.3c7.2-4 39.5-34.5 39.5-34.5 7.2-7.3 10.1-5.5 15.5 0 0 0 32.3 30.5 39.5 34.5 7.1 4 0.1 9.3 0.1 9.3zM261.4 475.1c118.4-2.9 213.8-100 213.8-219.1 0-17.3-2-34-5.9-50.1l-241.7-31.4 0.1 10.5 13.9 2s0.1 12.5 0.1 19.5c0 0.1 0 0.2 0 0.3 0 4.1-1.9 7.7-4.9 10.1l-9.5 7.4z'
      }
    ]
  }
})
